import { colors } from "@mui/material";

import theme from "@theme/index";

const CompanyDetailsDrawerStyles = {
  actionsIcon: {
    "&:hover": {
      "& .MuiSvgIcon-root.close-icon": {
        color: colors.red[500],
      },
      "& .MuiSvgIcon-root.flag-icon": {
        color: colors.orange[500],
      },
      backgroundColor: colors.grey[200],
      zIndex: 1,
    },
    "&:nth-of-type(2)": {
      borderLeft: `1px solid ${theme.palette.grey[400]}`,
    },
    alignItems: "center",
    backgroundColor: theme.palette.common.white,
    color: theme.palette.secondary.main,
    cursor: "pointer",
    display: "flex",
    height: "44px",
    justifyContent: "center",
    transition: "all 0.3s",
    width: "52px",
  },
  companyName: {
    maxWidth: "500px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  container: {
    alignItems: "flex-start",
    backgroundColor: theme.palette.grey[100],
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 2.5,
    height: "100%",
    overflowX: "hidden",
    overflowY: "auto",
    width: {
      lg: "85vw",
      md: "90vw",
      sm: "100vw",
      xl: "80vw",
      xs: "100vw",
    },
  },
  data: {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
  },
  dataContainer: {
    columnGap: "48px",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    mb: 3,
    px: 3,
    rowGap: "32px",
    width: "100%",
  },
  drawer: {
    ".MuiDrawer-paper": {
      bgcolor: theme.palette.common.white,
    },
  },
  flagDataLink: {
    "*": {
      "&:hover": {
        color: theme.palette.info.dark,
        textDecoration: "underline",
      },
      color: `${theme.palette.info.main} !important`,
    },
    alignItems: "center",
    cursor: "pointer",
    display: "flex",
    gap: 1,
    px: 3,
    py: 1,
    width: "100%",
  },
  header: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: {
      md: "row",
      xs: "column",
    },
    gap: 2,
    justifyContent: "space-between",
    pb: 2,
    pt: 5,
    px: 5,
    width: "inherit",
  },
  link: {
    cursor: "pointer",
    textDecoration: "underline",
  },
  logo: {
    maxHeight: "64px",
    maxWidth: "64px",
    [theme.breakpoints.down("md")]: {
      maxHeight: "48px",
      maxWidth: "72px",
    },
  },
  socialIcon: {
    "&:hover": {
      color: colors.blue[500],
    },
    color: theme.palette.grey[600],
    cursor: "pointer",
    fontSize: "24px",
    transition: "all 0.3s",
  },
};

export default CompanyDetailsDrawerStyles;
